import { crudResourceRegistry } from '@/Core/Services/CrudResourceRegistry'
import { toJS } from 'mobx'

export const ReloadActionHandlerTask = ({ crudContext }) => {
    // Якщо це list context - перезавантажуємо список
    if (crudContext.isList?.() || crudContext.contextType === 'list') {
        if (crudContext.listContext?.actions?.load) {
            crudContext.listContext.actions.load()
            return
        }
        console.warn('[ReloadActionHandlerTask] listContext.actions.load not found')
        return
    }
    
    // Якщо це detail context - отримуємо list context з registry
    if (crudContext.isDetail?.() || crudContext.contextType === 'detail') {
        const resourceKey = crudContext.resource?.key
        
        if (resourceKey) {
            // Отримуємо list context з registry
            const listContext = crudResourceRegistry.getListContext(resourceKey)
            
            if (listContext?.listContext?.actions?.load) {
                listContext.listContext.actions.load()
                return
            }
            
            console.warn('[ReloadActionHandlerTask] List context not found in registry for', resourceKey)
        }
        
        if (crudContext.formContext?.values?.id) {
            if (crudContext.formContext.isEditable) {
                crudContext.actions.edit(toJS(crudContext.formContext?.values))
            } else {
                crudContext.actions.view(toJS(crudContext.formContext?.values))
            }
        }
        return
    }
    
    console.warn('[ReloadActionHandlerTask] Unknown context type, cannot reload')
}
